import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';

/**
 * Extracts the agent workspace folder ID from application state.
 *
 * Only applies to co-scientist mode; returns null for all other agent types.
 */
export function getAgentWorkspaceFolderId(
  agentType: AgentType | null,
  applicationState: object | null
): string | null {
  if (agentType !== AgentType.CO_SCIENTIST || applicationState == null) {
    return null;
  }

  const state = applicationState as {agent_workspace_folder_id?: unknown};
  if (typeof state.agent_workspace_folder_id !== 'string') {
    return null;
  }

  return state.agent_workspace_folder_id;
}
